import { render, staticRenderFns } from "./BuildDividerBlock.vue?vue&type=template&id=457da759&scoped=true&"
import script from "./BuildDividerBlock.vue?vue&type=script&lang=js&"
export * from "./BuildDividerBlock.vue?vue&type=script&lang=js&"
import style0 from "./BuildDividerBlock.vue?vue&type=style&index=0&id=457da759&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457da759",
  null
  
)

export default component.exports